import { extendTheme } from "@chakra-ui/react";

export const appTheme = extendTheme({
  styles: { global: { body: { fontSize: "16px" } } },
  fonts: {
    heading: "jaf-facitweb",
    body: "Lora",
  },
  fontSizes: {
    "4xl": "28px",
    "3xl": "25px",
    "2xl": "22px",
    xl: "20px",
    lg: "18px",
    md: "16px",
  },
});
